<template>
    <div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <!-- <h5 class="card-category"></h5> -->
                        <h3 class="card-title">
                            Call centar
                        </h3>

                    </template>
                    
                    <div class="row">
                        <div class="col-md-2">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Početak (SMS/Digitalne karte)</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Početak" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.startStamp">
                                </el-date-picker>
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-2">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Kraj (SMS/Digitalne karte)</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Kraj" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.endStamp">
                                </el-date-picker>
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-2">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Broj telefona (SMS)</h4>
                            <base-input type="text" v-model="filter.phone" placeholder="Broj telefona (SMS)">
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-2">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Tablice</h4>
                            <base-input type="text" v-model="filter.plates" placeholder="Tablice">
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <!-- </div> -->

                        <!-- <div class="row"> -->

                        <!-- <div class="col-md-2">
                            <h4 slot="header" class="card-title">Status</h4>
                            <base-input>
                                <el-select v-model="filter.status" class="select-primary" clearable name="status">
                                    <el-option v-for="s in statuses" class="select-primary" :label="s.name"
                                        :value="s.status" :key="s.status"></el-option>
                                </el-select>
                            </base-input>
                        </div> -->
                        <div class="col-md-2">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title"> </h4>
                            <base-button class="mt-3" native-type="submit" type="primary"
                                @click="checkTickets(); checkWhitelist(); checkSms(); checkKioskTickets(); checkPaukTickets()">Pretraži</base-button>
                            <!-- </card> -->
                        </div>
                    </div>

                    <div v-if="paukTicket.id" class="row">
                        <div class="col-md-12">
                            <h4 slot="header" class="card-title">PAUK</h4>
                            <el-table :data="paukTickets" 
                                >



                                <el-table-column min-width="130" prop="stamp" label="Datum">
                                    <template slot-scope="scope">
                                        <span>{{ (new Date(scope.row.stampLong)).toLocaleString("de-DE") }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="80" prop="serviceNumber" label="Zaposleni">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.user?.name }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="100" prop="plates" label="Tablice">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.plates }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="100" prop="vehicle" label="Vozilo">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.vehicle }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="200" prop="street" label="Ulica">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.street }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="200" prop="ticketType" label="Tip">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.ticketType === 0"
                                            style="color: aquamarine;">ODNOŠENJE</span>
                                        <span v-if="scope.row.ticketType === 1" style="color: cadetblue;">LISICE</span>
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="200" prop="paukLocationId" label="Pauk lokacija">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.paukLocation?.name }}</span>
                                    </template>
                                </el-table-column>

                                <el-table-column min-width="130" prop="returned_stamp" label="Razduženo"
                                    sortable="custom">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.returnedStamp">{{ (new
                        Date(scope.row.returnedStampLong)).toLocaleString("de-DE") }}</span>
                                    </template>
                                </el-table-column>


                                <el-table-column min-width="200" header-align="right" align="right" label="Actions">
                                    <div slot-scope="scope" class="text-right table-actions">
                                        <base-button :type="'success'" class="btn-link" @click="getPaukTicket(scope.row)">
                                            Detalji
                                        </base-button>

                                    </div>
                                </el-table-column>
                            </el-table>
                        </div>
                        <br><br><br>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <card class="scrollable-card">
                                <h2 style="color: cadetblue;">Doplatne karte</h2>
                                <el-table :data="ticketData" v-loading="ticketsLoading"
                                    element-loading-text="Učitavanje..." element-loading-spinner="el-icon-loading"
                                    element-loading-background="rgba(0, 0, 0, 0.8)">
                                    <el-table-column min-width="100" prop="customer_name" label="Neplaćene">
                                        <template slot-scope="scope">
                                            <span style="color: red; cursor: pointer;" @click="tickets = openTickets">{{
                        scope.row.openTickets }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="100" prop="customer_name" label="Delimično plaćene">
                                        <template slot-scope="scope">
                                            <span style="color: orange; cursor: pointer;"
                                                @click="tickets = partialyPaidTickets">{{ scope.row.partialyPaidTickets
                                                }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="100" prop="customer_name" label="Plaćene">
                                        <template slot-scope="scope">
                                            <span style="color: green; cursor: pointer;"
                                                @click="tickets = paidTickets">{{ scope.row.paidTickets }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="100" prop="customer_name" label="Preplaćene">
                                        <template slot-scope="scope">
                                            <span style=" cursor: pointer;" @click="tickets = overpaidTickets">{{
                        scope.row.overpaidTickets }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="100" prop="customer_name" label="Poništene">
                                        <template slot-scope="scope">
                                            <span style=" cursor: pointer;" @click="tickets = canceledTickets">{{
                        scope.row.canceledTickets }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <h4>Detalji</h4>
                                <el-table :data="tickets" v-loading="ticketsLoading">


                                    <el-table-column min-width="130" prop="stamp" label="Datum" sortable="custom">
                                        <template slot-scope="scope">
                                            <span>{{ (new Date(scope.row.stampLong)).toLocaleString("de-DE") }}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column min-width="100" prop="client" label="Zona">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.client">{{ scope.row.client.name }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="200" prop="parking" label="Lokacija">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.parking">{{ scope.row.parking.name }}</span>
                                            <span v-else>{{ scope.row.parkingName }}</span>
                                        </template>
                                    </el-table-column>


                                    <el-table-column min-width="60" prop="price" label="Cena" sortable="custom">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.price }} EUR</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column min-width="100" prop="paymentStatus" label="Status">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.paymentStatus.id === '2'" style="color: red">{{
                        scope.row.paymentStatus.name }}</span>
                                            <span v-else-if="scope.row.paymentStatus.id === '1'" style="color: green">{{
                        scope.row.paymentStatus.name }}</span>
                                            <span v-else>{{ scope.row.paymentStatus.name }}</span>


                                        </template>
                                    </el-table-column>

                                    <el-table-column min-width="100" prop="ticket_number" label="ID" sortable="custom">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.ticketNumber }}</span>
                                        </template>
                                    </el-table-column>

                                </el-table>

                            </card>
                        </div>
                        <div class="col-md-6">
                            <card class="scrollable-card">
                                <h2 style="color: cadetblue;">Pretplatne/Besplatne karte</h2>
                                <el-table :data="whitelist" v-loading="whitelistLoading"
                                    element-loading-text="Učitavanje..." element-loading-spinner="el-icon-loading"
                                    element-loading-background="rgba(0, 0, 0, 0.8)">

                                    <el-table-column min-width="90" prop="plates" label="Tablice" sortable="custom">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.plates }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="110" prop="date_from" label="Od" sortable="custom">
                                        <template slot-scope="scope">
                                            <span>{{ (new Date(scope.row.dateFrom)).toLocaleString("de-De") }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="110" prop="date_to" label="Do" sortable="custom">
                                        <template slot-scope="scope">
                                            <span>{{ (new Date(scope.row.dateTo)).toLocaleString("de-De") }}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column min-width="100" prop="whitelist_type_id" label="Tip"
                                        sortable="custom">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.whitelistType?.name }}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column min-width="110" prop="status" label="Status" sortable="custom">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.status === 0 || scope.row.status === 5"
                                                style="background-color: green;">{{ scope.row.statusName }}</span>
                                            <span v-if="scope.row.status === 3 || scope.row.status === 4"
                                                style="background-color: orange; color: black">{{ scope.row.statusName
                                                }}</span>
                                            <span v-if="scope.row.status === 6" style="background-color: blue;">{{
                        scope.row.statusName }}</span>

                                            <span v-if="scope.row.status === 2 || scope.row.status === 1"
                                                style="background-color: red;">{{ scope.row.statusName }}</span>

                                        </template>
                                    </el-table-column>
                                </el-table>


                            </card>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <card class="scrollable-card">
                                <h2 style="color: cadetblue;">SMS
                                    <template v-if="!filter.startStamp && sms.length > 0">
                                        (Najnovije poruke: {{ sms.length }})
                                    </template>
                                    <template v-if="filter.startStamp && filter.endStamp">
                                        ({{ (new Date(filter.startStamp)).toLocaleString("de-DE") }} - {{ (new
                        Date(filter.endStamp)).toLocaleString("de-DE") }})
                                    </template>
                                </h2>
                                <el-table :data="sms" v-loading="whitelistLoading" element-loading-text="Učitavanje..."
                                    element-loading-spinner="el-icon-loading"
                                    element-loading-background="rgba(0, 0, 0, 0.8)">
                                    <el-table-column min-width="130" prop="stamp" label="Datum">
                                        <template slot-scope="scope">
                                            <span>{{ (new Date(scope.row.stampLong)).toLocaleString("de-DE") }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="80" prop="client" label="Zona">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.client?.name }}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column min-width="80" prop="plates" label="Tablice">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.plates }}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column min-width="80" prop="number" label="Telefon">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.number }}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column min-width="80" prop="phoneCode" label="Kod">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.phoneCode }}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column min-width="80" prop="operator" label="Operater">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.operator }}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column min-width="80" prop="price" label="Cena">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.price }} EUR</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column min-width="80" prop="status" label="Status">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.status === 0" style="color: #9BDAED;">NIJE
                                                OBRAĐENO</span>
                                            <span v-if="scope.row.status === 1" style="color: #49AFCB;">NAPLAĆENO</span>
                                            <span v-if="scope.row.status === 2" style="color: #49AFCB;">NE NAPLAĆUJE
                                                SE</span>
                                            <span v-if="scope.row.status === 3" style="color: red;">GREŠKA</span>
                                        </template>
                                    </el-table-column>
                                </el-table>


                            </card>
                        </div>
                        <div class="col-md-6">
                            <card class="scrollable-card">
                                <h2 style="color: cadetblue;">Digitalne karte
                                    <template v-if="!filter.startStamp && sms.length > 0">
                                        (Najnovije karte: {{ kioskTickets.length }})
                                    </template>
                                    <template v-if="filter.startStamp && filter.endStamp">
                                        ({{ (new Date(filter.startStamp)).toLocaleString("de-DE") }} - {{ (new
                        Date(filter.endStamp)).toLocaleString("de-DE") }})
                                    </template>
                                </h2>
                                <el-table :data="kioskTickets" v-loading="whitelistLoading"
                                    element-loading-text="Učitavanje..." element-loading-spinner="el-icon-loading"
                                    element-loading-background="rgba(0, 0, 0, 0.8)">
                                    <el-table-column min-width="130" prop="stamp" label="Datum">
                                        <template slot-scope="scope">
                                            <span>{{ (new Date(scope.row.stampLong)).toLocaleString("de-DE") }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="80" prop="client" label="Zona">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.client?.name }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="80" prop="kiosk" label="Kiosk">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.kiosk?.name }}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column min-width="80" prop="plates" label="Tablice">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.plates }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>


                            </card>
                        </div>
                    </div>

                </card>
            </div>
        </div>

        <modal :show.sync="showTicket" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showTicket = false;">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>


            <div class="row">
                <div class="col-md-12">
                    <card>
                        Opis: {{ paukTicket.description }}<br>
                        {{ paukTicket.plates }}<br>
                        {{ paukTicket.street }}<br>
                        {{ paukTicket.vehicle }}
                    </card>
                </div>

            </div>
            <div class="row">
                <div class="col-md-12">
                    <card>
                        <template v-for="img in paukTicket.images">
                        <img class="card-img" style="width: 150px;"
                            @click="image = 'https://budva.scancar.org:8443' + img; showImage = true"
                            :src="'https://budva.scancar.org:8443' + img" alt="Image" />&nbsp;
                    </template>
                    </card>
                </div>

            </div>
            
            

        </modal>
        <modal :show.sync="showImage" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showImage = false; image = null">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card class="stacked-form" title="Stacked Form">
                <h4 slot="header" class="card-title">{{ paukTicket.plates }}</h4>
                <img class="card-img" :src="image" alt="Image" />&nbsp;

            </card>


        </modal>
    </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem } from 'src/components';
import { TimeSelect, Table, TableColumn, Select, Option, DatePicker } from 'element-ui';
import { BaseCheckbox, BaseProgress, RouteBreadCrumb } from 'src/components';
import axios from '@/util/axiosinstance'

import swal from 'sweetalert2';
import { BaseNav, Modal } from '@/components';

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        TabPane,
        Tabs,
        Collapse,
        CollapseItem,
        Modal
    },
    mounted() {
        this.getCurrentUser()
        // this.getUsers()
        // this.getEmployees()
        // this.getKiosks()
        // this.getRegions()
        // this.getRoles()
    },
    data() {
        const now = new Date();

        // Postavljanje startStamp na 00:00:00 danas
        const startStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime();

        // Postavljanje endStamp na 23:59:59 danas
        const endStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();

        return {
            activeName: 'first',
            sectors: [],
            url: 'https://budva.scancar.org:8443/kuca',
            user: {},
            loading: false,
            filter: {
                startStamp: null,
                endStamp: null,
                plates: null
            },
            openTickets: [],
            paidTickets: [],
            canceledTickets: [],
            overpaidTickets: [],
            partialyPaidTickets: [],
            kioskTickets: [],
            sms: [],
            whitelist: [],
            ticketsLoading: false,
            ticketData: [],
            whitelistLoading: false,
            tickets: [],
            paukTicket: {},
            paukTickets: [],
            showTicket: false,
            image: null,
            showImage: false
        };
    },
    methods: {
        getPaukTicket(t) {
            this.loading = true

            axios.get(this.url + '/pauk/getTicket?id=' + t.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.paukTicket = result.data.ticket
                    this.showTicket = true
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },

        getCurrentUser() {
            this.zonesLoading = true
            axios.get(this.url + '/user/getUser').then(result => {
                this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.user = result.data.user
                    // alert(this.user.userName)
                } else {

                }
            })
        },
        checkPaukTickets() {
            this.paukTicket = {}
            this.paukTickets = []
            // this.ticketsLoading = true
            axios.post(this.url + '/callcenter/checkPaukTickets', this.filter).then(result => {
                // this.ticketsLoading = false

                if (result.data.result === 'ok') {
                    if (result.data.paukTicket) {
                        this.paukTicket = result.data.paukTicket
                        this.paukTickets.push(this.paukTicket)

                        if (this.paukTicket.ticketType === 0) {
                            const swalWithBootstrapButtons4 = swal.mixin({
                                customClass: {
                                    confirmButton: "btn btn-success btn-fill",
                                    cancelButton: "btn btn-danger btn-fill",
                                },
                                buttonsStyling: false,
                            });
                            let txt = "Vozilo je odneseno na lokaciju: " + this.paukTicket.paukLocation.name
                            swalWithBootstrapButtons4
                                .fire({
                                    title: txt,
                                    text: '',
                                    confirmButtonText: "U redu",
                                    // cancelButtonText: "ODUSTANI",
                                    showCancelButton: false,
                                })
                                .then((result) => {
                                    if (result.value) {

                                    }
                                });
                        }
                        if (this.paukTicket.ticketType === 1) {
                            const swalWithBootstrapButtons4 = swal.mixin({
                                customClass: {
                                    confirmButton: "btn btn-success btn-fill",
                                    cancelButton: "btn btn-danger btn-fill",
                                },
                                buttonsStyling: false,
                            });
                            let txt = "Vozilo ima lisice"
                            swalWithBootstrapButtons4
                                .fire({
                                    title: txt,
                                    text: '',
                                    confirmButtonText: "U redu",
                                    // cancelButtonText: "ODUSTANI",
                                    showCancelButton: false,
                                })
                                .then((result) => {
                                    if (result.value) {

                                    }
                                });
                        }
                    }

                } else {

                }
            })
        },
        checkSms() {
            this.sms = []
            this.ticketsLoading = true
            axios.post(this.url + '/callcenter/checkSms', this.filter).then(result => {
                this.ticketsLoading = false

                if (result.data.result === 'ok') {
                    this.sms = result.data.sms

                } else {

                }
            })
        },
        checkKioskTickets() {
            this.kioskTickets = []
            this.ticketsLoading = true
            axios.post(this.url + '/callcenter/checkKioskTickets', this.filter).then(result => {
                this.ticketsLoading = false

                if (result.data.result === 'ok') {
                    this.kioskTickets = result.data.kioskTickets

                } else {

                }
            })
        },
        checkTickets() {
            this.ticketData = []
            this.ticketsLoading = true
            axios.post(this.url + '/callcenter/checkTickets', this.filter).then(result => {
                this.ticketsLoading = false

                if (result.data.result === 'ok') {
                    this.openTickets = result.data.openTickets
                    this.paidTickets = result.data.paidTickets
                    this.canceledTickets = result.data.canceledTickets
                    this.overpaidTickets = result.data.overpaidTickets
                    this.partialyPaidTickets = result.data.partialyPaidTickets

                    this.tickets = this.openTickets

                    const d = {
                        openTickets: this.openTickets.length,
                        paidTickets: this.paidTickets.length,
                        canceledTickets: this.canceledTickets.length,
                        overpaidTickets: this.overpaidTickets.length,
                        partialyPaidTickets: this.partialyPaidTickets.length
                    }
                    this.ticketData = []
                    this.ticketData.push(d)
                } else {

                }
            })
        },
        checkWhitelist() {
            this.whitelist = []
            this.whitelistLoading = true
            axios.post(this.url + '/callcenter/checkWhitelist', this.filter).then(result => {
                this.whitelistLoading = false

                if (result.data.result === 'ok') {

                    // this.kioskTickets = result.data.kioskTickets
                    // this.sms = result.data.sms
                    this.whitelist = result.data.whitelist
                } else {

                }
            })
        },
        changePassword() {
            this.loading = true
            axios.post(this.url + '/user/changePassword', this.user).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.getCurrentUser()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        }
    }
};
</script>
<style lang="scss" scoped>
.scrollable-card {
    height: 500px;
    /* ili željena visina */
    overflow-y: auto;
    position: relative;
    /* po potrebi, ako ima apsolutno pozicioniranih elemenata */
}

/* Pozadina modala */
.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    /* Tamna pozadina */
    color: #ffffff;
    /* Svetli tekst */
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

/* Stil za telo modala */
.custom-modal-body {
    padding: 20px;
}

/* Stil za tabelu unutar modala */
.custom-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #2c2c3e;
    /* Tamna pozadina tabele */
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table th {
    background-color: #3c3c4f;
    /* Tamna pozadina za zaglavlje */
    color: #ffffff;
    /* Beli tekst */
    padding: 10px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.custom-table td {
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table tr:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Istaknuta boja za hover */
}


.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Visina loadera */
    background-color: rgba(255, 255, 255, 0.7);
    /* Providna pozadina */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    /* Iznad ostalog sadržaja */
}

.loader {
    border: 8px solid #f3f3f3;
    /* Svetla boja */
    border-top: 8px solid #3498db;
    /* Boja animacije */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>